import InputDialog from '../components/InputDialog.vue';

function Install (Vue, options = {}) {
  const property = options.property || '$inputDialog';
  delete options.property;

  const Ctor = Vue.extend(Object.assign(InputDialog));
  function createDialogCmp (options) {
    const container = document.querySelector('[data-app=true]') || document.body;
    return new Promise(resolve => {
      const cmp = new Ctor(Object.assign({}, {
        propsData: Object.assign({}, Vue.prototype[property].options, options),
        destroyed: () => {
          container.removeChild(cmp.$el);
          cmp.$mount().$el.firstChild.className -= ' open';
          cmp.$mount().$el.lastChild.className -= ' open';
          resolve(cmp.value);
        }
      }));
      container.appendChild(cmp.$mount().$el);
      var checkExist = setInterval(function() {
        if (document.querySelector('#confirm-screen')) {
          cmp.$mount().$el.firstChild.className += ' open';
          cmp.$mount().$el.lastChild.className += ' open';
          clearInterval(checkExist);
        }
      }, 100);
    });
  }

  function show (title, options = {}) {
    options.title = title;
    return createDialogCmp(options);
  }

  Vue.prototype[property] = show;
  Vue.prototype[property].options = options || {};
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Install);
}

export default Install;
